import { gql } from '@apollo/client';

export const LOCAL_PREDICTED_PRICE_FOR_ITALY = gql`
  query localPredictedPricesForItaly {
    predictedPricesForItaly @client
  }
`;
